// project import
import NavCollapse from './NavCollapse';
import NavItem from './NavItem';

// types
import { NavItemType } from 'types/menu';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

interface Props {
    item: NavItemType;
}

function NavGroup({ item }: Props) {
    return (
        <ul>
            {item.children?.map((menuItem) => {
                switch (menuItem.type) {
                    case 'collapse':
                        return <NavCollapse key={menuItem.id} menu={menuItem} level={1} />;
                    case 'item':
                        return <NavItem isPopup={false} key={menuItem.id} item={menuItem} level={1} />;
                    default:
                        return null;
                }
            })}
        </ul>
    );
}

export default NavGroup;
